import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { AnyARecord } from "dns";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/prcsmntr/xtrnusr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/prcs-mntr/xtrn-usrs`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    // External user account processing status !== 외부 사용자 계정처리현황 목록 ==!
    ptli0602001q: `${BASE.path}/ptli0602001q`,
    // External user account processing status details !== 외부 사용자 계정처리현황 상세 목록 ==!
    ptli0602002q: `${BASE.path}/ptli0602002q`,
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get the list of external user account processing status. !== 외부 사용자 계정처리현황 목록을 조회한다. ==!
    getXtrnUsrPrcsList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get the list of external user account processing status details. !== 외부 사용자 계정처리현황 상세 목록을 조회한다. ==!
    getXtrnUsrPrcsHistList: (xtrnUsrIdntfNo: any, page: number, size: number) => {
        return api.get(`${BASE.api}/${xtrnUsrIdntfNo}/hists?page=${page}&size=${size}`, {
            // params: comnUtils.toGetParams(data),
        });
    },
    // User status COMBO View !== 사용자 상태 COMBO 조회 ==!
    getAplyStatList: () => {
        return api.get(`${BASE.api}/aply-stat-list`, {});
    },

    // Get the excel list of external user account processing status. !== 외부 사용자 계정처리현황 엑셀셀목록을 조회한다. ==!
    getXtrnUsrPrcsExcelList: (data: AnyARecord) => api.get(
        `${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }
    ),

};

export const SF_USR_SEARCH_FORM: TFormSchema = {
    id: "form_infoSrch",
    schema: {
        /* request date !== 요청일자 ==!*/
        reqDateRnge: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "reqTimeStart" },
            end: { name: "reqTimeEnd" },
            rangeButton: 4,
        },
        /* User Status !== 사용자 상태 ==!*/
        aplyStat: {
            type: "select",
            label: "L_USR_STAT_CD",
            all: true,
        },
        /* External user application ID !== 외부 사용자 신청 아이디 ==!*/
        xtrnUsrIdntfNo: {
            type: "text",
            label: "L_TIN",
            edit: true,
        },
        /* User Name !== 사용자명 ==!*/
        usrNm: {
            type: "text",
            label: "L_NM",
            edit: true,
        },
    },
};

export const SG_USR_LIST: TGridSchema = {
    id: "grid_usrList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "xtrnUsrIdntfNo", width: "15%" }], id: "xtrnUsrAplyId" },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "*" }], id: "usrNm" },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "10%" }], id: "usrHistCnt" },
        { cells: [{ header: "L_STAT", binding: "aplyStat", width: "15%" }], id: "aplyStat" },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }], id: "lastMdfrId" },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }], id: "lastMdfyDtm" },
    ],
    body: [
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }] /* External user application ID !== 외부 사용자 신청 아이디 ==! */,
        },
        {
            cells: [{ binding: "usrNm", align: "left" }] /* User Name !== 사용자명 ==! */,
        },
        {
            cells: [{ binding: "usrHistCnt", align: "center" }] /* number of modifications !== 수정 건수 ==! */,
        },
        {
            cells: [{ binding: "aplyStat" }] /* application status !== 신청 상태 ==! */,
        },
        {
            cells: [{ binding: "lastMdfrId", align: "left" }] /* Last Modifier User Id */,
        },
        {
            cells: [{ binding: "lastMdfyDtm", type: "datetime" }] /* Last Modifier Date And Time */,
        },
    ],
};

export const SG_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_usrList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "xtrnUsrIdntfNo", width: "15%" }], id: "xtrnUsrAplyId" },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "*" }], id: "usrNm" },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "10%" }], id: "usrHistCnt" },
        { cells: [{ header: "L_STAT", binding: "aplyStat", width: "15%" }], id: "aplyStat" },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }], id: "lastMdfrId" },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }], id: "lastMdfyDtm" },
    ],
    body: [
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }] /* External user application ID !== 외부 사용자 신청 아이디 ==! */,
        },
        {
            cells: [{ binding: "usrNm", align: "left" }] /* User Name !== 사용자명 ==! */,
        },
        {
            cells: [{ binding: "usrHistCnt", align: "center" }] /* number of modifications !== 수정 건수 ==! */,
        },
        {
            cells: [{ binding: "aplyStat" }] /* application status !== 신청 상태 ==! */,
        },
        {
            cells: [{ binding: "lastMdfrId", align: "left" }] /* Last Modifier User Id */,
        },
        {
            cells: [{ binding: "lastMdfyDtm", type: "datetime" }] /* Last Modifier Date And Time */,
        },
    ],
};

export const SG_USR_DTL_LIST: TGridSchema = {
    id: "grid_usrDtlList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "xtrnUsrIdntfNo", width: "15%" }], id: "xtrnUsrIdntfNo" },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "20%" }], id: "usrNm" },
        { cells: [{ header: "L_STAT", binding: "aplyStat", width: "10%" }], id: "aplyStat" },
        { cells: [{ header: "L_RTRN_RSN", binding: "rtrnRsn", width: "*" }], id: "rtrnRsn" },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }], id: "lastMdfrId" },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }], id: "lastMdfyDtm" },
    ],
    body: [
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }] /* External user application ID !== 외부 사용자 신청 아이디 ==! */,
        },
        {
            cells: [{ binding: "usrNm", align: "left" }] /* User Name !== 사용자명 ==! */,
        },
        {
            cells: [{ binding: "aplyStat", align: "left" }] /* application status !== 신청 상태 ==! */,
        },
        {
            cells: [{ binding: "rtrnRsn", align: "left" }] /* Reason for rejection !== 반려 사유 ==! */,
        },
        {
            cells: [{ binding: "lastMdfrId", align: "left" }] /* Last Modifier User Id */,
        },
        {
            cells: [{ binding: "lastMdfyDtm", type: "datetime" }] /* Last Modifier Date And Time */,
        },
    ],
};
